/**
* directives.slider Module
*
* Description
*/
var app = angular.module('directives.sliderServices');

    app.factory('ModelSrv', ['$window', function($window){
        var self = this;

        function getHashValue(key) {
            var matches = $window.location.hash.match(new RegExp(key+'=([^&]*)'));
            return matches ? matches[1] : null;
        };

        function getCardA(){
            var cardA = getHashValue('cardA') || '';
            if(cardA.length > 0){
                return {cardA1: cardA.substring(0,4), cardA2: cardA.substring(4,8), cardA3: cardA.substring(8,12), cardA4: cardA.substring(12,16)};
            } else {
                return {cardA1: '', cardA2: '', cardA3: '', cardA4: ''};
            }
        };

        function getCardB(){
            var cardB = getHashValue('cardB') || '';
            if(cardB.length > 0){
                return {cardB1: cardB.substring(0,4), cardB2: cardB.substring(4,8), cardB3: cardB.substring(8,12), cardB4: cardB.substring(12,16)};
            } else {
                return {cardB1: '', cardB2: '', cardB3: '', cardB4: ''};
            }
        };

        return {
            cardA: getCardA(),
            cardB: getCardB(),
            summ: getHashValue('summ') || ''
        };

    }]);

app.service('ModelSrv', [function(){
        var self = this;

        self.cardA = '';
        self.cardB = '';
        self.summ = '';

        self.setCardA = function(value){
            self.cardA = value;
        };

        self.setCardB = function(value){
            self.cardB = value;
        };

        self.setSumm = function(value){
            self.summ = value;
        };
    }]);

 module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sliderServices/services/service.js
 ** module id = 228
 ** module chunks = 1
 **/